const COMMON_ENDPOINTS = {
  LOGIN_ENDPOINT : '/api/account/login',
  LOGOUT_ENDPOINT: '/api/account/logout',
  RESET_PASSWORD: '/api/account/resetpassword',
  FORGET_PASSWORD: '/api/account/forgetpassword',
  ACCOUNT_INFO: '/api/account/account-info',
  CHANGE_PASSWORD: '/api/account/changepassword',
  ACCOUNT_UPDATE: 'api/account/update-info',
  CALLBACK_ENDPOINT : '/api/account/callback',
};

const CAMPAIGN_ENPOINTS = {
  CAMPAIGN_LIST: '/api/campaign/list',
  CAMPAIGN_RETRIEVE: '/api/campaign/retrieve',
  CAMPAIGN_CREATE: '/api/campaign/create',
  CAMPAIGN_UPDATE: '/api/campaign/update',
  CAMPAIGN_DELETE: '/api/campaign/delete',
  CAMPAIGN_STATISTIC: '/api/campaign/statistic',
  CAMPAIGN_LIST_USERS: 'api/campaign/list-users',
  CAMPAIGN_UPDATE_USER: 'api/campaign/update-user',
  CAMPAIGN_DELETE_USERS: 'api/campaign/delete-users',
};

const CAMPAIGN_USER_ENDPOINTS = {
  CAMPAIGN_USER_LIST: '/api/campaign-user/list',
  CAMPAIGN_USER_RETRIEVE: '/api/campaign-user/retrieve',
  CAMPAIGN_USER_CREATE: '/api/campaign-user/create',
  CAMPAIGN_USER_BULK_CREATE: '/api/campaign-user/bulk-create',
  CAMPAIGN_USER_UPDATE: '/api/campaign-user/update',
  CAMPAIGN_USER_DELETE: '/api/campaign-user/delete',
  CAMPAIGN_USER_INIT_ACCOUNT: '/api/campaign-user/init-account',
};

const DATA_ENDPOINTS = {
  DATA_ORG_LIST: '/api/data/org-list',
};

const LICENSE_ENDPOINTS = {
  LICENSE_CREATE: '/api/license/create',
  LICENSE_DELETE: '/api/license/delete',
};

const ORG_ENDPOINTS = {
  ORG_RETRIEVE: '/api/organisation/retrieve',
  ORG_LIST: '/api/organisation/list',
  ORG_CREATE: '/api/organisation/create',
  ORG_UPDATE: '/api/organisation/update',
  ORG_DELETE: '/api/organisation/delete',
  ORG_STATISTIC: '/api/organisation/statistic',
};

const RBAC_ENDPOINTS = {
  RBAC_RETRIEVE: '/api/rbac/retrieve',
  RBAC_LIST: '/api/rbac/list',
  RBAC_CREATE: '/api/rbac/create',
  RBAC_UPDATE: '/api/rbac/update',
  RBAC_DELETE: '/api/rbac/delete',
};

const SAVED_SEARCH_ENDPOINTS = {
  SAVED_SEARCH_LIST: '/api/saved-search/list',
  SAVED_SEARCH_CREATE: '/api/saved-search/create',
  SAVED_SEARCH_UPDATE: '/api/saved-search/update',
  SAVED_SEARCH_DELETE: '/api/saved-search/delete',
};

const SCOUT_AI_ENDPOINTS = {
  SCOUT_AI_LIST: '/api/scout-ai/list',
  SCOUT_AI_DATA_LIST: '/api/scout-ai/data/list',
  SCOUT_AI_RETRIEVE: '/api/scout-ai/retrieve',
  SCOUT_AI_CREATE: '/api/scout-ai/create',
  SCOUT_AI_UPDATE: '/api/scout-ai/update',
  SCOUT_AI_DELETE: '/api/scout-ai/delete',
  SCOUT_AI_GRADUATE: '/api/scout-ai/graduate',
  SHARE_SCOUT_AI: '/api/sharescoutai/create',
};

const KEYDEV_ENDPOINTS = {
  KEY_DEV_LIST: '/api/keydev/list',
  KEY_DEV_LOGS: '/api/keydev/logs',
  KEY_DEV_REPORT: '/api/keydev/report',
  KEY_DEV_RETRIEVE: '/api/keydev/retrieve',
  KEY_DEV_RULE: '/api/keydev/rule',
  KEY_DEV_CHECK_UPDATING_STATUS: '/api/keydev/checkUpdatingStatus',
  KEY_DEV_MARKING: '/api/keydev/marking',
  KEY_DEV_CORRECTION_HISTORY: '/api/keydev/correctionHistory',
  KEY_DEV_TOPIC_LIST: '/api/keydev/topic',
  PUBLISHER_LIST: '/api/keydev/listPublisher',
  CLUSTER_DETAIL: '/api/keydev/clusterDetail',
  CLUSTER_UPDATE: '/api/keydev/clusterUpdate',
  KEY_DEV_CORRECTION: '/api/keydev/correction',
  KEY_DEV_RELATED: '/api/keydev/related',
};

const SEER_DEMO_ENDPOINTS = {
  SEER_PREDICTION_ADD: '/api/seer/prediction/add',
  SEER_PEEK_STATUS: '/api/seer/prediction/peekstatus',
  SEER_RETRIEVE_PREDICTION: '/api/seer/prediction/retrieve',
};

const SUBSCRIPTION_ENDPOINTS = {
  SUB_LIST: '/api/subscription/list',
  SUB_RETRIEVE: '/api/subscription/retrieve',
  SUB_CREATE: '/api/subscription/create',
  SUB_UPDATE: '/api/subscription/update',
  SUB_DELETE: '/api/subscription/delete',
  SUB_PERSONAL_CREATE: '/api/subscription/personal-create',
  SUB_LIST_BY_USER_GUID: '/api/subscription/list-by-user',
  SUB_LIST_BY_ORGANISATION_GUID: '/api/subscription/list-by-organisation',
};

const SUBSCRIPTION_PLAN_ENDPOINTS = {
  SUB_PLAN_RETRIEVE: '/api/sub-plan/retrieve',
  SUB_PLAN_LIST: '/api/sub-plan/list',
  SUB_PLAN_CREATE: '/api/sub-plan/create',
  SUB_PLAN_UPDATE: '/api/sub-plan/update',
  SUB_PLAN_DELETE: '/api/sub-plan/delete',
};

const USER_ENDPOINTS = {
  USER_RETRIEVE: '/api/user/retrieve',
  USER_LIST: '/api/user/list',
  USER_CREATE: '/api/user/create',
  USER_UPDATE: '/api/user/update',
  USER_DELETE: '/api/user/delete',
  USER_LINK: '/api/user/link',
  USER_DELINK: '/api/user/delink',
  USER_CHANGE_ORG: '/api/user/change-org',
  USER_REQUEST_TOKEN: '/api/user/request-token',
};

const TARGET_LIST_ENDPOINTS = {
  TARGET_LIST_RETRIEVE: '/api/target-list/retrieve',
  TARGET_LIST_LIST: '/api/target-list/list',
  TARGET_LIST_CREATE: '/api/target-list/create',
  TARGET_LIST_UPDATE: '/api/target-list/update',
  TARGET_LIST_DELETE: '/api/target-list/delete',
  TARGET_LIST_ITEM_ADD: '/api/target-list/add-item',
  TARGET_LIST_ITEM_DELETE: '/api/target-list/delete-item',
};

const ARTICLE_ENDPOINTS = {
  ARTICLE_RETRIEVE: '/api/article/retrieve',
  ARTICLE_RETRIEVE_BY_IDS: '/api/article/retrieveByIds',
  ARTICLE_SEARCH: '/api/article/search',
  ARTICLE_SCOUT_RESULT: '/api/article/scout-result'
};

export const SCOUT_AI_RESULT_ENDPOINTS = {
  ARTICLE_TRAINING: '/api/scoutairesult/article-training',
  INTERNAL_TRAINING: '/api/scoutairesult/internal-training',
  INITIAL_TRAINING: '/api/scoutairesult/initial-training',
  CONTINUOUS_TRAINING: '/api/scoutairesult/continuous-training',
  RETRIEVE_SCOUT_AI_RESULT: '/api/scoutairesult/retrieve-result',
  REMOVE_SCOUT_TRAINING: '/api/scoutairesult/remove-training',
};

export const TAAS_CONFIG_ENDPOINTS = {
  RETRIEVE: '/api/taasconfig/retrieve',
  LIST: '/api/taasconfig/list',
  CREATE: '/api/taasconfig/create',
  UPDATE: '/api/taasconfig/update',
  DELETE: '/api/taasconfig/delete',
  SET_ACTIVE: '/api/taasconfig/setactive',
};

export const NERD_TRAINING_ENDPOINTS = {
  SEARCH_ENTITIES: '/api/nerdTraining/searchEntities',
  FETCH_ARTICLE: '/api/nerdTraining/fetchArticle',
  FETCH_ARTICLE_STATUS: '/api/nerdTraining/fetchArticleStatus',
  FETCH_ARITCLE_TAGGING: '/api/nerdTraining/fetchArticleTagging',
  SUBMIT_ARTICLE: '/api/nerdTraining/submitArticle',
};

export const COMPANY_ENDPOINTS = {
  RETRIEVE: '/api/companies/retrieve',
  RETRIEVE_COMPANY_PEOPLE: '/api/retrieve/company/people',
  COMPANY_RETRIEVE_BY_IDS: '/api/companies/retrieveByIds',
};

export const APIM_ENDPOINTS = {
  SUBSCRIPTION_LIST: '/api/apim/subscription-list',
  SUBSCRIPTION_CREATE: '/api/apim/subscription-create',
};

export const AUTHENTICATION_ENDPOINTS = {
  GET_USER_ACCESS_STATISTICS: '/api/authentication/getUserAccessStatistics',
  RETRIEVE_TENANT_INFO: '/api/authentication/retrieveTenantInfo',
  CREATE_TENANT: '/api/authentication/createTenant',
  UPDATE_TENANT: '/api/authentication/updateTenant',
  DEACTIVATE_TENANT: '/api/authentication/deactivateTenant',
}

export const API_ENDPOINT = {
  ...ARTICLE_ENDPOINTS,
  ...COMMON_ENDPOINTS,
  ...CAMPAIGN_ENPOINTS,
  ...CAMPAIGN_USER_ENDPOINTS,
  ...DATA_ENDPOINTS,
  ...LICENSE_ENDPOINTS,
  ...ORG_ENDPOINTS,
  ...RBAC_ENDPOINTS,
  ...SAVED_SEARCH_ENDPOINTS,
  ...SCOUT_AI_ENDPOINTS,
  ...SEER_DEMO_ENDPOINTS,
  ...SUBSCRIPTION_ENDPOINTS,
  ...SUBSCRIPTION_PLAN_ENDPOINTS,
  ...USER_ENDPOINTS,
  ...TARGET_LIST_ENDPOINTS,
  ...KEYDEV_ENDPOINTS,
  ...NERD_TRAINING_ENDPOINTS,
  ...COMPANY_ENDPOINTS,
  ...APIM_ENDPOINTS,
  ...AUTHENTICATION_ENDPOINTS,
};